var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"text-white"},[_c('section-hero',{attrs:{"section-hero":_vm.sectionHero}}),_vm._v(" "),_c('section-values',{attrs:{"section-values":_vm.sectionValues}}),_vm._v(" "),_c('section-timeline',{attrs:{"section-timeline":_vm.sectionTimeline}}),_vm._v(" "),_c('section-join-us')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }